import { User } from "lucide-react"

// A chapter's first page, as the print layout builds it from the chapter's
// details (not from the AI's text): kicker, title, leader, headshot, and the
// Life Verse. Used by the coach's review page and the leader's link.
export function ChapterOpening({ title, subtitle, leaderName, leaderRole, leaderCompany, leaderCity, headshotUrl, lifeVerse }) {
  return (
    <header className="mb-8 border-b pb-8 text-center">
      <div className="font-serif text-xs font-bold uppercase tracking-[0.2em] text-kf-red">A Kingdom Factors Profile</div>
      <div className="mt-3 font-serif text-2xl font-bold uppercase">{title}</div>
      {subtitle && <div className="mt-1 italic text-zinc-600">{subtitle}</div>}
      <div className="mt-5 font-serif text-lg font-bold uppercase">{leaderName}</div>
      <div className="italic text-zinc-600">{[leaderRole, leaderCompany].filter(Boolean).join(", ")}</div>
      <div className="text-sm text-zinc-600">{leaderCity}</div>
      <div className="mx-auto mt-4 flex h-32 w-26 items-center justify-center overflow-hidden rounded bg-zinc-100">
        {headshotUrl ? <img src={headshotUrl} alt={leaderName} className="h-full w-full object-cover" /> : <User className="h-8 w-8 text-zinc-400" />}
      </div>
      {lifeVerse?.text && (
        <div className="mx-auto mt-5 max-w-md border-y-2 border-kf-red py-3">
          <div className="font-serif text-[0.65rem] font-bold uppercase tracking-[0.2em] text-kf-red">Life Verse</div>
          <q className="italic">{lifeVerse.text}</q>
          <div className="mt-1 font-serif text-xs uppercase tracking-wider">{lifeVerse.reference}</div>
        </div>
      )}
    </header>
  )
}
